// extracted by mini-css-extract-plugin
export var education = "socials-module--education--R-0am";
export var socials = "socials-module--socials--14jcj";